/**
 * 风控状态 + 申诉 API(W-8 风控条)。均需 REGISTERED。
 *   GET  /api/v1/risk/me       → { status, canAppeal, latestAppealStatus, ... }
 *   POST /api/v1/risk/appeals  { reason(10-500) } → { appealId, status, createdAt }
 * 生成的 RiskStatusResponse 为 envelope 包装,此处本地声明内层 payload;申诉请求用生成类型。
 */
import { call } from './client';
import type { components } from './openapi.generated';

type Schemas = components['schemas'];

export type RiskStatus = 'NORMAL' | 'DEGRADED' | 'BANNED';
export type AppealStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

export interface RiskStatusResult {
  status: RiskStatus;
  triggeredAt?: string | null;
  reasonEventType?: string | null;
  canAppeal: boolean;
  latestAppealStatus?: AppealStatus | null;
}

export interface SubmitAppealResult {
  appealId: string;
  status: string;
  createdAt: string;
}

export function getRiskStatus(): Promise<RiskStatusResult> {
  return call<RiskStatusResult>({ method: 'GET', url: '/api/v1/risk/me' });
}

export function submitAppeal(reason: string): Promise<SubmitAppealResult> {
  return call<SubmitAppealResult>({
    method: 'POST',
    url: '/api/v1/risk/appeals',
    data: { reason } satisfies Schemas['SubmitAppealRequest'],
  });
}
